import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  loadedFeature = 'event';

  ngOnInit() {
    firebase.initializeApp(environment.firebase);
  }

  onNavigate(feature: string) {
    this.loadedFeature = feature;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts